// Shared geometry helpers for DraggableEdge and WorkflowBuilder's edge-right-click menu, so
// "add a waypoint here" inserts at the same segment regardless of which gesture triggered it
// (double-click the line vs the context menu's "Add Waypoint").

// Shortest distance from point `p` to the segment a->b.
export function distanceToSegment(p, a, b) {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const lengthSq = dx * dx + dy * dy;
  if (lengthSq === 0) return Math.hypot(p.x - a.x, p.y - a.y);
  let t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / lengthSq;
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(p.x - (a.x + t * dx), p.y - (a.y + t * dy));
}

// Given `points` = [source, ...waypoints, target] and a click position, returns the index into
// the WAYPOINTS array (not `points`) a new point should be inserted at to land in the same spot
// in the segment list as the click. Straight-line segments are a fine approximation for this
// even once the rendered path is curved (see DraggableEdge's smoothPath) — it only decides
// insertion order, not the point's actual position.
export function findInsertionIndex(points, click) {
  let bestSegment = 0;
  let bestDist = Infinity;
  for (let i = 0; i < points.length - 1; i++) {
    const dist = distanceToSegment(click, points[i], points[i + 1]);
    if (dist < bestDist) {
      bestDist = dist;
      bestSegment = i;
    }
  }
  return bestSegment;
}
